import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { groupInput, input, nonEmptyValidator } from "@redotech/ui/form";
import { bijectionOptional } from "@redotech/util/bijection";
import { storeTransform } from "@redotech/util/store";
import { StringFormat, symbolStringFormat } from "@redotech/util/string-format";
import { localStore } from "@redotech/web-util/storage";

export type ScanMode = typeof ScanMode.PRINT | typeof ScanMode.VERIFY_PRINT;

export namespace ScanMode {
  export const PRINT = Symbol("print");
  export const VERIFY_PRINT = Symbol("verify_print");
}

export const scanModeFormat: StringFormat<ScanMode> = symbolStringFormat([
  ScanMode.PRINT,
  ScanMode.VERIFY_PRINT,
]);

export const scanModeStore = storeTransform(
  localStore("redo.scanMode"),
  bijectionOptional(scanModeFormat),
);

export const scanModeOptions: RedoListItem<ScanMode>[] = [
  {
    id: ScanMode.VERIFY_PRINT,
    type: "text",
    text: "Verify and print",
    value: ScanMode.VERIFY_PRINT,
  },
  { id: ScanMode.PRINT, type: "text", text: "Print", value: ScanMode.PRINT },
];

export const verifyForm = groupInput({
  barcode: input<string>({ validator: nonEmptyValidator }),
});
